





import { DaTeacherService } from '../../biz/remote/DaTeacherService';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { OptionsDTO } from '../../../src_server/entity/dto/OptionsDTO';
import { DaCourseOperatorDTO } from '../../../src_server/entity/dto/DaCourseOperatorDTO';
import { DaCourseOperator } from '../../../src_server/entity/generated/DaCourseOperator';
@Component({ components: {} })
export default class CourseOperatorSection extends Vue {
  operators: OptionsDTO[] = [];

  courseOperators: DaCourseOperatorDTO[] = [];
  value = '';

  @Prop({ default: '' })
  private user_id!: string;

  get model() {
    return this.value;
  }
  set model(value: string) {
    this.$emit('input', value);
  }

  get selected() {
    return this.courseOperators.map((c) => c.da_course_operator.operator_user_id).join(',');
  }

  set selected(value: string) {
    const selectedUsers = value.split(',').map((couse_user_id) => {
      const entity = new DaCourseOperator();
      entity.teacher_user_id = this.user_id;
      entity.operator_user_id = couse_user_id;
      return entity;
    });
    console.log(selectedUsers);
    this.$emit('selected', selectedUsers);
  }

  async getCourseOperator() {
    const biz = new DaTeacherService();
    const response = await biz.getCourseOperator(this.user_id);
    this.courseOperators = response.data;
  }

  async created() {
    const biz = new DaTeacherService();
    const response = await biz.getAllOperator(Session.getSessionBuildingId());
    this.operators = response.data.map((ua) => {
      return OptionsDTO.init(ua.user_id!, ua.user_name!);
    });

    this.getCourseOperator();
  }
}
